import DisplayResults from './DisplayResults'
export { DisplayResults }
export default DisplayResults
